import { ReactNode } from "react";

export type DrawerMenuItemType = {
  id: string;
  text: string;
  onMenuClick?: () => void;
  iconComponent?: ReactNode;
};

export type DrawerMenuItemsType = DrawerMenuItemType & {
  submenu?: DrawerMenuItemType[];
};

export const menuItems = (
  userRole: string[],
  navigate: (param: string) => void
) => {
  if (!userRole) {
    return;
  }

  // const menuItems = {};
  return [];
};
